import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper p-0 p-lg-3" }
const _hoisted_2 = { class: "font-weight-bold mb-4 d-flex flex-row justify-content-between align-items-center p-3 p-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-dark-100 alert-styled-left alert-arrow-left alert-dismissible" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "alert"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "×")
  ]),
  /*#__PURE__*/_createTextVNode(" Hier konfigurieren Sie für jedes Ereignis den Interventionsplan, welcher im Falle eines eingehenden Ereignisses abgearbeitet werden soll. Sie können für jedes Ereignis einen individuellen Plan festlegen. ")
], -1)
const _hoisted_4 = { class: "card-header bg-white" }
const _hoisted_5 = { class: "card-title d-flex flex-column" }
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-0" }
const _hoisted_9 = { class: "btn bg-transparent border-blue text-blue rounded-round border-2 btn-icon mr-3" }
const _hoisted_10 = { class: "flex-fill d-flex flex-column" }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "float-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-forward" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_17 = { class: "media bg-light font-weight-semibold py-2" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "d-flex flex-row align-items-center" }
const _hoisted_20 = { class: "d-flex flex-row align-items-center" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = /*#__PURE__*/_createElementVNode("small", null, "Interventionen", -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "icon-cog" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["id"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "mr-3" }
const _hoisted_31 = {
  href: "#",
  class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon"
}
const _hoisted_32 = { class: "media-body d-flex flex-row align-items-center" }
const _hoisted_33 = { class: "d-flex flex-column" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Mo - So | ")
const _hoisted_35 = { class: "text-muted" }
const _hoisted_36 = { class: "d-flex flex-row mt-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_38 = {
  key: 1,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_39 = { class: "media bg-light font-weight-semibold p-3 text-center" }
const _hoisted_40 = { class: "mr-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "media-body" }, " Sie haben noch keinen Interventionsplan für dieses Ereignis angelegt. ", -1)
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("li", { class: "bg-light font-weight-semibold p-3 text-center" }, " Für diese Anlage wurden keine Ereignisse zum Konfigurieren hinterlegt. ", -1)
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, pIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: pIndex,
        class: "card bg-white"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h6", _hoisted_5, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(project.p_firma) + " | ", 1),
              _createElementVNode("small", null, "#" + _toDisplayString(project.pid), 1)
            ]),
            _createElementVNode("small", _hoisted_6, _toDisplayString(project.p_strasse) + " " + _toDisplayString(project.p_hnr) + ", " + _toDisplayString(project.p_plz) + " " + _toDisplayString(project.p_ort), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.systems, (system, sIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: sIndex,
              class: "mb-5"
            }, [
              _createElementVNode("legend", _hoisted_8, [
                _createElementVNode("a", _hoisted_9, [
                  _createElementVNode("i", {
                    class: _normalizeClass(system.icon),
                    "aria-hidden": "true"
                  }, null, 2)
                ]),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(system.anlage_bemerkung) + " | ", 1),
                    _createElementVNode("small", null, "#" + _toDisplayString(system.anlage_nummer), 1)
                  ]),
                  _createElementVNode("small", _hoisted_11, _toDisplayString(_ctx.stringToDate(system.anlage_einbau, "de")), 1)
                ]),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary btn-sm",
                    onClick: ($event: any) => (_ctx.showSystemOverview(project.pid, system.anlage_id))
                  }, _hoisted_15, 8, _hoisted_13)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.interventionTypes, (type, tIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: tIndex }, [
                  (type.interventions.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                        _createElementVNode("li", _hoisted_17, [
                          _createElementVNode("a", {
                            class: "text-body collapsed d-flex flex-row align-items-center justify-content-between w-100",
                            href: '#collapse-icon'+sIndex+'-'+tIndex,
                            "data-toggle": "collapse"
                          }, [
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.interventionTypes[tIndex].name), 1),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("span", null, [
                                _createElementVNode("b", null, _toDisplayString(type.interventions.length), 1),
                                _hoisted_21,
                                _hoisted_22
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary-100 text-secondary btn-sm mr-2 ml-2",
                                onClick: ($event: any) => (_ctx.showInterventions(project.pid, system.anlage_id, tIndex))
                              }, _hoisted_25, 8, _hoisted_23),
                              _createElementVNode("a", {
                                href: "",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                                class: "text-body",
                                "data-toggle": "collapse",
                                "aria-expanded": "false"
                              }, _hoisted_27)
                            ])
                          ], 8, _hoisted_18)
                        ]),
                        _createElementVNode("div", {
                          class: "collapse",
                          id: 'collapse-icon'+sIndex+'-'+tIndex
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.interventions, (intervention, iIndex) => {
                            return (_openBlock(), _createElementBlock("li", { key: iIndex }, [
                              _createElementVNode("a", {
                                class: "media cursor-pointer align-items-center",
                                onClick: ($event: any) => (_ctx.editIntervention(project.pid, system.anlage_id, intervention.interventionType, intervention.id))
                              }, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("a", _hoisted_31, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass([_ctx.interventionTypes[intervention.interventionType]['icon'], "icon-big"])
                                    }, null, 2)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", null, [
                                      _hoisted_34,
                                      _createElementVNode("small", _hoisted_35, _toDisplayString(_ctx.timeRanges[intervention.timeRange].name), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervention.contactOrder, (unit, uIndex) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: uIndex,
                                          class: "badge bg-accent mr-1"
                                        }, _toDisplayString(_ctx.interventionTypes[intervention.interventionType]?.[unit]?.name), 1))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _hoisted_37
                              ], 8, _hoisted_29)
                            ]))
                          }), 128))
                        ], 8, _hoisted_28)
                      ]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                        _createElementVNode("li", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.interventionTypes[tIndex].name), 1),
                          _hoisted_41,
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              class: "btn btn-info",
                              onClick: ($event: any) => (_ctx.showInterventions(project.pid, system.anlage_id, tIndex))
                            }, "Anlegen", 8, _hoisted_42)
                          ])
                        ])
                      ]))
                ], 64))
              }), 128)),
              (!system.interventionTypes || system.interventionTypes.length <= 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_43, _hoisted_45))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}